import { useEffect } from "react";
import { MapContainer, TileLayer, Marker, useMap } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

// Fix per icona di default Leaflet (problema noto con bundler tipo webpack/CRA)
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
  iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
  shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
});

// Custom icon FabriGroup (pin rosso neon)
const neonIcon = L.divIcon({
  className: "",
  html: `
    <div style="
      width: 30px; height: 30px;
      background: radial-gradient(circle at 30% 30%, #ff5577, #ff0033 70%, #aa0022 100%);
      border: 2px solid #fff;
      border-radius: 50% 50% 50% 0;
      transform: rotate(-45deg);
      box-shadow: 0 0 18px #ff0033, 0 4px 12px rgba(0,0,0,0.6);
      display: flex; align-items: center; justify-content: center;
    ">
      <div style="
        width: 8px; height: 8px;
        background: #fff;
        border-radius: 50%;
        transform: rotate(45deg);
      "></div>
    </div>
  `,
  iconSize: [30, 30],
  iconAnchor: [15, 30],
});

function Recenter({ lat, lng, zoom }) {
  const map = useMap();
  useEffect(() => {
    if (lat && lng) map.flyTo([lat, lng], zoom || 16, { duration: 0.8 });
  }, [lat, lng, zoom, map]);
  return null;
}

/**
 * LocationMap — Mappa Leaflet interattiva con pin sull'indirizzo selezionato.
 * Tile provider: OpenStreetMap (gratuito, mondiale).
 *
 * Props:
 *  - lat, lng: coordinate del pin (richiesti per mostrare il marker)
 *  - label: testo da mostrare nel popup (opz.)
 *  - height: altezza CSS (default 240px)
 *  - zoom: zoom iniziale (default 16)
 *  - className: classi tailwind aggiuntive sul wrapper
 *  - dark: true (default) usa tile dark (Carto)
 */
export default function LocationMap({
  lat,
  lng,
  label = "",
  height = 240,
  zoom = 16,
  className = "",
  dark = true,
  testid,
}) {
  const hasCoords = typeof lat === "number" && typeof lng === "number" && !isNaN(lat) && !isNaN(lng);
  // default Roma se non ci sono coordinate
  const center = hasCoords ? [lat, lng] : [41.9028, 12.4964];

  const tileUrl = dark
    ? "https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png"
    : "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png";
  const attribution = dark
    ? '&copy; <a href="https://www.openstreetmap.org/copyright">OSM</a> &copy; <a href="https://carto.com/attributions">CARTO</a>'
    : '&copy; <a href="https://www.openstreetmap.org/copyright">OSM</a>';

  return (
    <div
      data-testid={testid || "location-map"}
      className={`relative rounded-xl overflow-hidden border border-white/10 ${className}`}
      style={{ height }}
    >
      <MapContainer
        center={center}
        zoom={hasCoords ? zoom : 5}
        scrollWheelZoom={true}
        style={{ width: "100%", height: "100%", background: "#0a0a0a" }}
      >
        <TileLayer url={tileUrl} attribution={attribution} />
        {hasCoords && (
          <>
            <Recenter lat={lat} lng={lng} zoom={zoom} />
            <Marker position={[lat, lng]} icon={neonIcon} />
          </>
        )}
      </MapContainer>
      {!hasCoords && (
        <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
          <div className="px-4 py-2 rounded-full bg-black/70 backdrop-blur-sm border border-white/10 text-[11px] uppercase tracking-widest text-white/60">
            Nessun indirizzo selezionato
          </div>
        </div>
      )}
      {hasCoords && label && (
        <div className="absolute bottom-2 left-2 right-2 px-3 py-1.5 rounded-lg bg-black/80 backdrop-blur-sm border border-[#ff0033]/30 text-[11px] text-white/85 pointer-events-none truncate">
          <span className="text-[#ff5577] mr-1.5">●</span> {label}
        </div>
      )}
    </div>
  );
}
